      var mode;
      var datePicker;

      const modes = {
          DELIVERY: 'delivery',
          PICKUP: 'pick up'
      };

      $(document).ready( function() {
         
          // Init datepicker
        
              datePicker = $('.cart-datepicker').datepicker( {
                  minDate: +0,
                  maxDate: '+2M',
                  beforeShowDay: nonWorkingDates,
                  dateFormat: 'D d M yy'
              });       
        
        setupForm();

        // Toggle mode
        $('.btn-mode').change(function(){
          if($(this).val() == 'Delivery'){
            mode = modes.DELIVERY;      
          }else{
            mode = modes.PICKUP;           
          };
          setupForm();
        });

      });


      function setupForm(){  
        
       // console.log('Mode: '+ mode + ' Past close: ' + isPastHour(16) + ' Past midday ' + isPastHour(12));
        
        if(mode){
          if(mode == modes.PICKUP){
            $('.panel-delivery input').removeAttr('required'); 
            //$('.panel-pickup input').prop('required',true);
          };
          if(mode == modes.DELIVERY){
            $('.panel-delivery input').prop('required',true);
            //$('.panel-pickup input').removeAttr('required'); 
          };
          $('.panel-date').show();
          $('.panel-date input').prop('required',true);
          $('.panel-notes').show();
          $('.label-mode').text(mode);
          $('.panel-delivery').toggle(mode == modes.DELIVERY);  
          //$('.panel-pickup').toggle(mode == modes.PICKUP); 
          // disable todays date on datepicker if too late
          if((mode == modes.PICKUP && isPastHour(16)) || (mode == modes.DELIVERY && isPastHour(12))){
          	$('.cart-datepicker').datepicker('option', {minDate: +1});            
          }else{
          	$('.cart-datepicker').datepicker('option', {minDate: +0});
          };          
        }else{
          $('.panel-delivery').hide();
          $('.panel-pickup').hide();
    	  $('.panel-date').hide();
          $('.panel-notes').hide();          
        };  
      };
  
// date picker - Original done by??? 

  function nonWorkingDates(date) {
    var day = date.getDay(),
        Sunday = 0,
        Monday = 1,
        Tuesday = 2,
        Wednesday = 3,
        Thursday = 4,
        Friday = 5,
        Saturday = 6;
	// Add specific closed dates here e.g. public holidays format [month,day,year]
    var closedDates = [        
        [10, 21, 2023]
    ];

    var closedDays = [[Sunday]];

    // Valentines collection check (collection ID and bool is set in cart.liquid) by M.E. 23/1/24
    // Disables dates specified below if items from specified collection are in cart

    if(valentinesCollection){
      closedDates.push([1, 23, 2024]);
      closedDates.push([1, 24, 2024]);
      closedDates.push([1, 25, 2024]);
      closedDates.push([1, 26, 2024]);
      closedDates.push([1, 27, 2024]);
      closedDates.push([1, 28, 2024]);
      closedDates.push([1, 29, 2024]);
      closedDates.push([1, 30, 2024]);
      closedDates.push([1, 31, 2024]);
      closedDates.push([2, 1, 2024]);
      closedDates.push([2, 2, 2024]);
      closedDates.push([2, 3, 2024]);
      closedDates.push([2, 4, 2024]);
      closedDates.push([2, 5, 2024]);
      closedDates.push([2, 6, 2024]);
      closedDates.push([2, 7, 2024]);
      //closedDates.push([2, 29, 2024]);
    };

    // Adds closed dates from metaobject (defined in cart.liquid)
    addMetaObjectDates(closedDates);

    /* Mother's day check- allows specified date to be selected for Pickup / Delivery */
    var mothersDay = [05, 11, 2025]; // Set date for Mother's Day here
    if (date.getMonth() === mothersDay[0] - 1 &&
        date.getDate() === mothersDay[1] &&
        date.getFullYear() === mothersDay[2]) {
            return [true];
    }
    
    // Added by Hiro @shopify on February 4 2021
    var valentinesDay = [02, 14, 2021];
    /* Valentine's day check: */
    if (date.getMonth() === valentinesDay[0] - 1 &&
        date.getDate() === valentinesDay[1] &&
        date.getFullYear() === valentinesDay[2]) {
            return [true];
    }

    for (var i = 0; i < closedDays.length; i++) {
        if (day == closedDays[i][0]) {
            return [false];
        }
    }
    
    for (i = 0; i < closedDates.length; i++) {
        if (date.getMonth() == closedDates[i][0] - 1 &&
            date.getDate() == closedDates[i][1] &&
            date.getFullYear() == closedDates[i][2]) {

            return [false];
        }
    }
    	return [true];
  }


function isPastHour(hour) {
    d = new Date();
    utc = d.getTime() + (d.getTimezoneOffset() * 60000);
    nd = new Date(utc + (3600000*10));
    var hours = nd.getHours();
    return hours >= hour
}
  
function isPastMidday() {
    d = new Date();
    utc = d.getTime() + (d.getTimezoneOffset() * 60000);
    nd = new Date(utc + (3600000*10));
    var hours = nd.getHours();
    return hours >= 12
}

function isPastClose() {
    d = new Date();
    utc = d.getTime() + (d.getTimezoneOffset() * 60000);
    nd = new Date(utc + (3600000*10));
    var hours = nd.getHours();
    return hours >= 16
}

// metaobject test
function addMetaObjectDates(closedDates){
  if (typeof metaClosedDates !== 'undefined' && metaClosedDates.length > 0) {
    //console.log(metaClosedDates);
    for (var i = 0; i < metaClosedDates.length; i++) { 
      const newDate = metaClosedDates[i].split("-");
      let year = newDate[0];
      let month = newDate[1];
      let day = newDate[2];
      //console.log(year);
      //console.log(month);
      //console.log(day);
      closedDates.push([month, day, year]);
    }
  }
}
